import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DeviceIdComparerService {

    constructor() { }

    /**
     * @deprecated: Created to combine comparison logic in one place.
     * In the future, we must rely on the SA Device ID format only (example: eMC3-015649727574581).
     */
    public areDeviceIdsEqual = (mcOrSaDeviceIdA: string, mcOrSaDeviceIdB: string): boolean => {
        if (!mcOrSaDeviceIdA || !mcOrSaDeviceIdB) {
            return false;
        }

        let result = false;

        if (mcOrSaDeviceIdA === mcOrSaDeviceIdB) {
            result = true;
        }

        // "mcOrSaDeviceIdA" is a MobiControl device identifier (mcOrSaDeviceIdA=d0f88c2dbcb0),
        // "mcOrSaDeviceIdB" is a SotiAssist device identifier (mcOrSaDeviceIdB=eMC3-d0f88c2dbcb0).
        if (!result && mcOrSaDeviceIdB.endsWith(mcOrSaDeviceIdA)) {
            result = true;
        }

        // "mcOrSaDeviceIdB" is a MobiControl device identifier (mcOrSaDeviceIdB=d0f88c2dbcb0),
        // "mcOrSaDeviceIdA" is a SotiAssist device identifier (mcOrSaDeviceIdA=eMC3-d0f88c2dbcb0).
        if (!result && mcOrSaDeviceIdA.endsWith(mcOrSaDeviceIdB)) {
            result = true;
        }

        return result;
    };
}
